import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TruckIcon, ShieldCheckIcon, CreditCardIcon } from '@heroicons/react/24/outline';
import { SparklesIcon } from '@heroicons/react/24/solid';

export const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implémenter l'inscription à la newsletter
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <footer className="bg-white">
      {/* Avantages - Icônes */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="text-center group hover:scale-105 transition-transform duration-300">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-[#c69c70]/10 rounded-full group-hover:bg-[#c69c70]/20 transition-colors">
                <TruckIcon className="h-10 w-10 text-[#c69c70]" />
              </div>
              <h3 className="font-medium text-[#c69c70] mb-2 tracking-wide text-sm uppercase">Livraison OFFERTE</h3>
              <p className="text-gray-600 text-sm font-light">
                en Europe
              </p>
            </div>
            
            <div className="text-center group hover:scale-105 transition-transform duration-300">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-[#c69c70]/10 rounded-full group-hover:bg-[#c69c70]/20 transition-colors">
                <ShieldCheckIcon className="h-10 w-10 text-[#c69c70]" />
              </div>
              <h3 className="font-medium text-[#c69c70] mb-2 tracking-wide text-sm uppercase">Paiement sécurisé</h3>
              <p className="text-gray-600 text-sm font-light">
                paiement en 3 x
              </p>
            </div>
            
            <div className="text-center group hover:scale-105 transition-transform duration-300">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-[#c69c70]/10 rounded-full group-hover:bg-[#c69c70]/20 transition-colors">
                <SparklesIcon className="h-10 w-10 text-[#c69c70]" />
              </div>
              <h3 className="font-medium text-[#c69c70] mb-2 tracking-wide text-sm uppercase">Fabriqué en France</h3>
              <p className="text-gray-600 text-sm font-light">
                par nos artisans
              </p>
            </div>
            
            <div className="text-center group hover:scale-105 transition-transform duration-300">
              <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-[#c69c70]/10 rounded-full group-hover:bg-[#c69c70]/20 transition-colors">
                <CreditCardIcon className="h-10 w-10 text-[#c69c70]" />
              </div>
              <h3 className="font-medium text-[#c69c70] mb-2 tracking-wide text-sm uppercase">Garantie</h3>
              <p className="text-gray-600 text-sm font-light">
                1 an
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer principal */}
      <div className="bg-[#5a5a5a] text-white">
        <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* AIDE */}
          <div>
            <h3 className="text-[#c69c70] font-semibold text-sm uppercase tracking-wider mb-4">
              AIDE
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contactez-nous" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Contactez-nous
                </Link>
              </li>
              <li>
                <Link to="/guide-tailles" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Guide des tailles bagues
                </Link>
              </li>
              <li>
                <Link to="/echanges-retours" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Échanges & retours
                </Link>
              </li>
              <li>
                <Link to="/expedition-livraison" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Expédition & livraison sécurisée
                </Link>
              </li>
              <li>
                <Link to="/sav" className="text-gray-300 hover:text-white text-sm transition-colors">
                  SAV
                </Link>
              </li>
              <li>
                <Link to="/entretien" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Conseils d'entretien
                </Link>
              </li>
            </ul>
          </div>

          {/* À PROPOS */}
          <div>
            <h3 className="text-[#c69c70] font-semibold text-sm uppercase tracking-wider mb-4">
              À PROPOS
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/paiement-securise" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Paiement sécurisé
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/cgu-cgv" className="text-gray-300 hover:text-white text-sm transition-colors">
                  CGU/CGV
                </Link>
              </li>
              <li>
                <Link to="/politique-cookies" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Politique relative aux cookies
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Cookie Policy (EU)
                </Link>
              </li>
            </ul>
          </div>

          {/* PRESSE */}
          <div>
            <h3 className="text-[#c69c70] font-semibold text-sm uppercase tracking-wider mb-4">
              PRESSE
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/presse" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Nos parutions presse
                </Link>
              </li>
            </ul>
          </div>

          {/* NEWSLETTER */}
          <div className="lg:col-span-2">
            <h3 className="text-[#c69c70] font-semibold text-sm uppercase tracking-wider mb-4">
              RECEVEZ NOTRE ACTUALITÉ
            </h3>
            <form onSubmit={handleNewsletterSubmit} className="mb-4">
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="S'inscrire à la newsletter"
                  className="flex-1 px-4 py-2 bg-white text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-[#c69c70]"
                  required
                />
                <button
                  type="submit"
                  className="px-6 py-2 bg-[#4a9fd8] hover:bg-[#3d8bc2] text-white font-semibold text-sm transition-colors"
                >
                  OK
                </button>
              </div>
            </form>
            <p className="text-gray-400 text-xs mb-6">
              En validant, j'accepte la{' '}
              <Link to="/politique-confidentialite" className="underline hover:text-white">
                politique de confidentialité
              </Link>
            </p>

            {/* SUIVEZ-NOUS */}
            <h3 className="text-[#c69c70] font-semibold text-sm uppercase tracking-wider mb-4">
              SUIVEZ-NOUS
            </h3>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-[#6a6a6a] hover:bg-[#c69c70] rounded-full transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-[#6a6a6a] hover:bg-[#c69c70] rounded-full transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                </svg>
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-[#6a6a6a] hover:bg-[#c69c70] rounded-full transition-colors"
                aria-label="YouTube"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a
                href="https://www.pinterest.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-[#6a6a6a] hover:bg-[#c69c70] rounded-full transition-colors"
                aria-label="Pinterest"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Ligne de séparation */}
        <div className="border-t border-gray-600 pt-6">
          <div className="text-center text-gray-400 text-sm">
            <p className="mb-2">
              <a href="tel:+33677267276" className="hover:text-white transition-colors">
                📞 +33 6 77 26 72 76
              </a>
              {' - '}
              <span>67200 Arles - France</span>
            </p>
            <p className="text-xs">
              © {new Date().getFullYear()} AUPIHO Joaillerie. Tous droits réservés.
            </p>
          </div>
        </div>
        </div>
      </div>
    </footer>
  );
};

